<template>
  <v-container
    krypart
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        xs12
      >
        <material-card
          title="鍵盤品質分析"
          class="card-mix card-shrink card-padding v-card__first"
          color="general"
        >
          <!-- <router-link
            v-if="processingView"
            :to="'/keypart/keyboard/keyboardAoiAnalyzer/'+responseWeeksStart+'/'+responseWeeksEnd+'/'+responseVendorName+'/'+responseModelName+'/'+responsePartNumber"
            class="mix-btn p-0"
            target="_blank">
            <v-btn
              class="black text-light mx-0">
              AOI CPK
            </v-btn>
          </router-link> -->
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout
                wrap
                align-items-center>
                <v-flex
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryVendorName"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryVendorNameMenu"
                    label="廠商"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryModelName"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryModelNameMenu"
                    label="機種"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryPartNumber"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryPartNumberMenu"
                    label="料號"
                    class="v-text-field__slot"
                    color="white"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg5>
                  <v-autocomplete
                    v-model="summaryWeeksStart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryAllYearWeeksList"
                    label="上傳檔案起始時間"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  >
                    <template v-slot:item="data">
                      <div
                        :class="{'weeks-list-data-tip':contentDateListWeeks.indexOf(data.item.value)!==-1}"
                        class="v-list__tile__content">
                        <div class="v-list__tile__title">
                          {{ data.item.text }}
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>
                  <p class="m-0 text-center px-3">到</p>
                  <v-autocomplete
                    v-model="summaryWeeksEnd"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryAllYearWeeksList"
                    label="上傳檔案結束時間"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  >
                    <template v-slot:item="data">
                      <div
                        :class="{'weeks-list-data-tip':contentDateListWeeks.indexOf(data.item.value)!==-1}"
                        class="v-list__tile__content">
                        <div class="v-list__tile__title">
                          {{ data.item.text }}
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  lg1
                  text-xs-right
                >
                  <v-btn
                    :disabled="summaryWeeksStart===''||summaryWeeksEnd===''||summaryVendorName===''||summaryModelName===''||summaryPartNumber===''"
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doSubmit()"
                  >
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>分析
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex
        v-if="processingView"
        style="padding: 0px 0px 0px 0px!important;"
        selenium-grab
        p-0
        m-0
        layout
        wrap
        lg12>
        <v-flex
          xs12
          sm6
          lg2>
          <material-stats-card
            :value="responseModelName"
            style="margin:10px 0 !important;"
            class="v-offset-none"
            color="purple"
            icon="mdi-folder-open"
            title="案名"/>
        </v-flex>
        <v-flex
          xs12
          sm6
          lg3>
          <material-stats-card
            :value="responseVendorName"
            style="margin:10px 0 !important;"
            class="v-offset-none"
            icon="mdi-factory"
            title="廠商"/>
        </v-flex>
        <v-flex
          xs12
          sm6
          lg3>
          <material-stats-card
            :value="responsePartNumber"
            style="margin:10px 0 !important;"
            class="v-offset-none"
            icon="mdi-factory"
            title="料號"/>
        </v-flex>
        <v-flex
          xs12
          sm6
          lg4>
          <material-stats-card
            :value="responseDateStart +' 至 '+ responseDateEnd"
            style="margin:10px 0 !important;"
            color="indigo"
            icon="mdi-calendar"
            title="上傳資料日期"/>
        </v-flex>
        <v-flex
          v-if="systemTrigger && overloadMsg!==''"
          class="data-area no-data-page"
          xs12
          v-html="'<p>錯誤訊息:'+overloadMsg+'</p>'"/>
        <v-flex
          v-if="summaryNoData && overloadMsg===''"
          class="data-area no-data-page"
          xs12>
          此日期區間查無資料
        </v-flex>
        <v-flex
          v-if="!summaryNoData && overloadMsg===''"
          lg7
        >
          <material-card
            title="RGB"
            class="card-shrink card-padding v-card__first"
            color="orange-5"
          >
            <div
              v-if="responseCpkData.Rgb.length>0"
              class="data-area rgb">
              <div
                v-for="(group,g) in responseCpkData.Rgb"
                :key="'g'+g"
                class="data-group">
                <div class="data-group-name">{{ group.buttonCode.toUpperCase() }}</div>
                <div class="data-set">
                  <div
                    v-for="(item,i) in group.item"
                    :key="'i'+i"
                    :class="{ 'ordinary':doCpkGrade(item.value),'bad':!doCpkGrade(item.value) }"
                    class="data-box">
                    <div class="data-item">
                      <span class="data-item-name">{{ item.testItemName.toUpperCase() }}</span>
                      <span
                        class="data-item-value"
                        style="cursor: pointer;"
                        @click="doSubmitSingle('Rgb', item.group, item.testItemName)">{{ item.value.toFixed(2) }}</span>
                      <span class="data-item-detail">{{ doCpkGradeName(item.value) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="data-area no-data">
              此日期區間查無資料
            </div>
          </material-card>
        </v-flex>
        <v-flex
          v-if="!summaryNoData && overloadMsg===''"
          lg5
        >
          <material-card
            title="Feeling"
            class="card-shrink card-padding v-card__first"
            color="orange-4"
          >
            <div
              v-if="responseCpkData.Feeling.length>0"
              class="data-area feeling"
              style="flex-flow: row;">
              <div
                v-for="(group,g) in responseCpkData.Feeling"
                :key="'g'+g"
                class="data-group">
                <div class="data-group-name">
                  <span>{{ group.buttonCode }}</span>CPK
                  <p
                    :style="!doCpkGrade(group.item[1].value)?'color:red;font-weight:500!important;':''"
                    class="cpk"
                    @click="doSubmitSingle('Feeling', null, group.buttonCode)">{{ group.item[1].value.toFixed(2) }}</p>
                  <p
                    :style="doCpkGrade(group.item[1].value)?'color:#ffffff;background-color:green;font-weight:900!important;':'color:#ffffff;background-color:red;font-weight:900!important;'"
                    class="lv">{{ doCpkGradeName(group.item[1].value) }}</p>
                </div>
                <div class="data-set">
                  <div
                    v-for="(item,i) in group.item"
                    v-show="item.statType!=='cpk'"
                    :key="'i'+i"
                    class="data-box">
                    <div class="data-item">
                      <span class="data-item-name">{{ item.statType.toUpperCase() }}</span>
                      <span class="data-item-value">{{ item.value.toFixed(2) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="data-area no-data">
              此日期區間查無資料
            </div>
          </material-card>
          <material-card
            v-if="responseCpkData.Feeling.length>0"
            class="card-padding">
            <div
              v-for="(key,k) in responseProblemData.Feeling"
              :key="'k'+k"
              class="fail-data-row">
              <div class="fail-data-title"><p>{{ key.testItemName }}</p>Problem key</div>
              <div class="fail-data-key">
                <span
                  v-for="(code,c) in key.buttonCode"
                  :key="'c'+c">{{ code }}</span>
              </div>
            </div>
          </material-card>
        </v-flex>
        <v-flex
          v-if="!summaryNoData && overloadMsg===''"
          lg5
        >
          <material-card
            title="Key Height"
            class="card-shrink card-padding v-card__first"
            color="orange-3"
          >
            <div
              v-if="responseCpkData.Key_Height.length>0"
              class="data-area feeling key-height">
              <div
                v-for="(group,g) in responseCpkData.Key_Height"
                :key="'g'+g"
                class="data-group">
                <div class="data-group-name">
                  CPK
                  <p
                    :style="!doCpkGrade(group.item[1].value)?'color:red;font-weight:500!important;':''"
                    class="cpk"
                    style="cursor: pointer;"
                    @click="doSubmitSingle('Key_Height', null, 'height')">{{ group.item[1].value.toFixed(2) }}</p>
                  <p
                    :style="doCpkGrade(group.item[1].value)?'color:#ffffff;background-color:green;font-weight:900!important;':'color:#ffffff;background-color:red;font-weight:900!important;'"
                    class="lv">{{ doCpkGradeName(group.item[1].value) }}</p>
                </div>
                <div class="data-set">
                  <div
                    v-for="(item,i) in group.item"
                    v-show="item.statType!=='cpk'"
                    :key="'i'+i"
                    class="data-box">
                    <div class="data-item">
                      <span class="data-item-name">{{ item.statType.toUpperCase() }}</span>
                      <span class="data-item-value">{{ item.value.toFixed(2) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="data-area no-data">
              此日期區間查無資料
            </div>
          </material-card>
          <material-card
            v-if="responseCpkData.Key_Height.length>0"
            class="card-padding">
            <div class="fail-data-row">
              <div class="fail-data-title">Problem key</div>
              <div class="fail-data-key">
                <span
                  v-for="(key,k) in responseProblemDataCompile.Key_Height"
                  :key="'k'+k">{{ key }}</span>
              </div>
            </div>
          </material-card>
        </v-flex>
        <v-flex
          v-if="!summaryNoData && overloadMsg===''"
          lg3
        >
          <material-card
            title="Luminance"
            class="card-shrink card-padding v-card__first"
            color="orange-2"
          >
            <div
              v-if="responseCpkData.Luminance.length>0"
              class="data-area luminance">
              <div
                v-for="(group,g) in responseCpkData.Luminance"
                :key="'g'+g"
                class="data-group">
                <div class="data-set">
                  <div
                    v-for="(item,i) in group.item"
                    :key="'i'+i"
                    :class="{ 'ordinary':doCpkGrade(item.value),'bad':!doCpkGrade(item.value) }"
                    class="data-box">
                    <div class="data-item">
                      <span class="data-item-name">{{ item.testItemName.toUpperCase() }}</span>
                      <span
                        class="data-item-value"
                        style="cursor: pointer;"
                        @click="doSubmitSingle('Luminance', null, item.testItemName)">{{ item.value.toFixed(2) }}<span class="uniformity">≥{{ item.detail.uniformity }}</span></span>
                      <span class="data-item-detail">{{ doCpkGradeName(item.value) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="data-area no-data">
              此日期區間查無資料
            </div>
          </material-card>
          <material-card
            v-if="responseCpkData.Luminance.length>0"
            class="card-padding">
            <div class="fail-data-row">
              <div class="fail-data-title">Problem key</div>
              <div class="fail-data-key">
                <span
                  v-for="(key,k) in responseProblemDataCompile.Luminance"
                  :key="'k'+k">{{ key }}</span>
              </div>
            </div>
          </material-card>
        </v-flex>
        <v-flex
          v-if="!summaryNoData && overloadMsg===''"
          lg4
        >
          <material-card
            title="Aoi"
            class="card-shrink card-padding v-card__first"
            color="orange-1"
          >
            <div
              v-if="responseCpkData.Aoi.length>0"
              class="data-area luminance aoi">
              <div
                v-for="(group,g) in responseCpkData.Aoi"
                :key="'g'+g"
                class="data-group">
                <div class="data-set">
                  <div
                    v-for="(item,i) in group.item"
                    :key="'i'+i"
                    :class="{ 'ordinary':doCpkGrade(item.value),'bad':!doCpkGrade(item.value) }"
                    class="data-box">
                    <div class="data-item">
                      <span class="data-item-name">{{ item.testItemName.toUpperCase() }}</span>
                      <span
                        class="data-item-value"
                        style="cursor: pointer;"
                        @click="doSubmitSingle('Aoi', null, item.testItemName)">{{ item.value.toFixed(2) }}<span class="uniformity">({{ item.detail.lowerLimitSpec }},{{ item.detail.upperLimitSpec }})</span></span>
                      <span class="data-item-detail">{{ doCpkGradeName(item.value) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="data-area no-data">
              此日期區間查無資料
            </div>
          </material-card>
          <material-card
            v-if="responseCpkData.Aoi.length>0"
            class="card-padding">
            <div
              v-for="(key,k) in responseProblemData.Aoi"
              :key="'k'+k"
              class="fail-data-row">
              <div class="fail-data-title"><p>{{ key.testItemName }}</p>Problem key</div>
              <div class="fail-data-key">
                <span
                  v-for="(code,c) in key.buttonCode"
                  :key="'c'+c">{{ code }}</span>
              </div>
            </div>
          </material-card>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="chartLineView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <v-card
        max-width="80%"
        style="margin:0 auto;">
        <v-card-text>
          <v-alert
            v-model="chartLineView"
            class="mt-3 mb-3 border-0"
            color="brown">
            <strong class="h4">{{ responseStandardData?responseStandardData.testItemName:'' }} ： {{ responseDateStart }} - {{ responseDateEnd }} ｜ {{ responseVendorName }} ｜ {{ responseModelName }} ｜ {{ responsePartNumber }}</strong>
          </v-alert>
          <div class="d-flex">
            <div class="w-100 m-3">
              <p class="text-center my-1">{{ chartViewTestItemName }}{{ chartViewButtonCode?' [ '+chartViewButtonCode+' ] ':'' }}</p>
              <div class="keypart-chart-info">
                <div :class="{ 'ordinary':doCpkGrade(responseStandardData.cpk),'bad':!doCpkGrade(responseStandardData.cpk) }">
                  <span>CPK</span>
                  <p>{{ responseStandardData.cpk.toFixed(2) }}</p>
                  <div>
                    <span>{{ doCpkGradeName(responseStandardData.cpk) }}</span>
                  </div>
                </div>
                <div>
                  <span>SPEC</span>
                  <p>{{ responseStandardData.lowerSpecValue }}{{ (responseStandardData.lowerSpecValue!==null&&responseStandardData.upperSpecValue!==null)?' ~ ':'' }}{{ responseStandardData.upperSpecValue }}</p>
                  <div>
                    <span v-if="responseStandardData.lowerSpecValue!==null">LOWER</span>
                    <span v-if="responseStandardData.upperSpecValue!==null">UPPER</span>
                  </div>
                </div>
              </div>
              <table class="keypart-chart-table statistic-table">
                <thead>
                  <tr>
                    <th>sigma</th>
                    <th>value</th>
                    <th>histogram</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(row, r) in responseStandardData.distributionCoverageList">
                    <tr
                      v-if="row.define.type === 'Sigma'"
                      :key="'r'+r">
                      <td>{{ row.define.name }}</td>
                      <td>{{ row.define.value.toFixed(4) }}</td>
                      <td>{{ row.amount }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <vue-c3
              :handler="handler_line"
              class="keypart-chart-area"/>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="red"
            small
            @click="chartLineView=false">
            <v-icon class="mr-2">mdi-close</v-icon>關閉
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="processloadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'
import VueC3 from 'vue-c3'
import 'c3/c3.min.css'
import { mapState } from 'vuex'
import NormalDistribution from 'normal-distribution'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'KeyboardManufacturingReport',
  components: {
    VueC3
  },
  data () {
    return {
      startdate: '2018-04-01',
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      overload: false,
      overloadMsg: '',
      processingView: false,
      summaryNoData: true,
      systemTrigger: false,
      summaryLoading: {
        Rgb: false,
        Feeling: false,
        Key_Height: false,
        Luminance: false,
        Aoi: false,
        Problem_Feeling: false,
        Problem_Key_Height: false,
        Problem_Luminance: false,
        Problem_Aoi: false
      },
      summaryMonth: this.$moment(new Date()).format('YYYY-MM'),
      summaryWeeksStart: Number(this.$moment(new Date()).format('YYYY')) * 100 + Math.ceil((((new Date(this.$moment(new Date()).format('YYYY-MM-DD')) - new Date(new Date(this.$moment(new Date()).format('YYYY'), 0, 1))) / 86400000) + new Date(new Date(this.$moment(new Date()).format('YYYY'), 0, 1)).getDay()) / 7) - parseInt((new Date(this.$moment(new Date()).format('YYYY') + '-01-01').getDay() + 5) / 6),
      summaryWeeksEnd: Number(this.$moment(new Date()).format('YYYY')) * 100 + Math.ceil((((new Date(this.$moment(new Date()).format('YYYY-MM-DD')) - new Date(new Date(this.$moment(new Date()).format('YYYY'), 0, 1))) / 86400000) + new Date(new Date(this.$moment(new Date()).format('YYYY'), 0, 1)).getDay()) / 7) - parseInt((new Date(this.$moment(new Date()).format('YYYY') + '-01-01').getDay() + 5) / 6),
      summaryVendorNameMenu: [],
      summaryModelNameMenu: [],
      summaryPartNumberMenu: [],
      summaryVendorName: '',
      summaryModelName: '',
      summaryPartNumber: '',
      summaryYearWeeksList: [],
      summaryAllYearWeeksList: [],
      tempVendorName: '',
      tempModelName: '',
      tempPartNumber: '',
      CpkGradeList: [],
      contentDateList: [],
      responseVendorName: '',
      responseModelName: '',
      responsePartNumber: '',
      responseDateStart: '',
      responseDateEnd: '',
      responseWeeksStart: '',
      responseWeeksEnd: '',
      responseCpkData: {
        Rgb: [],
        Feeling: [],
        Key_Height: [],
        Luminance: [],
        Aoi: []
      },
      responseProblemData: {
        Feeling: [],
        Key_Height: [],
        Luminance: [],
        Aoi: []
      },
      responseProblemDataCompile: {
        Feeling: [],
        Key_Height: [],
        Luminance: [],
        Aoi: []
      },
      responseStandardData: {
        cpk: 0
      },
      chartLineView: false,
      chartLineViewNum: 0,
      chartLineViewName: '',
      chartViewButtonCode: '',
      chartViewTestItemName: '',
      barXaxisName: [],
      barXaxisValue: [],
      WeekList: ['日', '一', '二', '三', '四', '五', '六'],
      handler_line: new Vue()
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    processloadingView () {
      if (!this.summaryLoading.Rgb && !this.summaryLoading.Feeling && !this.summaryLoading.Key_Height && !this.summaryLoading.Luminance && !this.summaryLoading.Aoi && !this.summaryLoading.Problem_Feeling && !this.summaryLoading.Problem_Key_Height && !this.summaryLoading.Problem_Luminance && !this.summaryLoading.Problem_Aoi) {
        return false
      } else {
        return true
      }
    },
    responseStandardUpperLower () {
      const array = []
      let ULindex = this.responseStandardData.upperSpecValue !== null ? -0.5 : null
      let LLindex = this.responseStandardData.lowerSpecValue !== null ? -0.5 : null
      this.responseStandardData.distributionCoverageList.map(function (e) {
        if (e.define.type === 'Sigma') {
          return e.define
        } else {
          return null
        }
      }).filter(Boolean).forEach((r, rr) => {
        if (this.responseStandardData.lowerSpecValue > r.value) {
          LLindex = rr + 0.5
        }
        if (this.responseStandardData.upperSpecValue >= r.value) {
          ULindex = rr + 0.5
        }
      })
      if (ULindex) {
        array.push({ value: ULindex, text: 'Upper Spec Value' })
      }
      if (LLindex) {
        array.push({ value: LLindex, text: 'Lower Spec Value' })
      }
      return array
    },
    options_line () {
      return {
        data: {
          x: 'x',
          columns: [
            this.barXaxisName,
            this.barXaxisStandard,
            this.barXaxisValue
          ],
          axes: {
            常態分佈: 'y2'
          },
          type: 'bar',
          types: {
            常態分佈: 'spline'
          }
        },
        axis: {
          x: {
            type: 'category',
            padding: {
              top: 0,
              right: 0.1,
              bottom: 0,
              left: 0.2
            }
          },
          y: {
            tick: {
              format: function (value) { return value }
            },
            label: {
              text: '統計次數',
              position: 'outer-middle'
            }
          },
          y2: {
            tick: {
              format: function (value) { return value }
            },
            label: {
              text: '常態分佈',
              position: 'outer-middle'
            },
            show: true
          }
        },
        tooltip: {
          order: function (t1, t2) {
            return t1.id < t2.id
          },
          contents: (d, value, ratio, id) => {
            return '<table class="c3-tooltip"><tbody><tr><th colspan="2">' + this.barXaxisName[d[1].index + 1] + '</th></tr><tr class="c3-tooltip-name--統計次數"><td class="name"><span style="background-color:#1f77b4"></span>統計次數</td><td class="value">' + d[1].value + '</td></tr></tbody></table>'
          }
          // format: {
          //   title: (d, value) => {
          //     return `${this.barXaxisName[d + 1]}`
          //   },
          //   value: (value, ratio, id) => {
          //     // if (id === '常態分佈') {
          //     //   return `${value.toFixed(3)}`
          //     // } else {
          //     //   return `${value}`
          //     // }
          //   }
          // }
          // order: 'asc'
        },
        grid: {
          x: {
            show: true,
            lines: this.responseStandardUpperLower
          },
          y: {
            show: true
          }
        },
        legend: {
          position: 'bottom',
          padding: 16,
          show: false
        },
        size: {
          width: ((window.innerWidth - this.shrink) * 0.5) - 64,
          height: 500
        },
        spline: {
          interpolation: {
            type: 'monotone'
          }
        }
      }
    },
    contentDateListWeeks () {
      const array = []
      this.summaryYearWeeksList.forEach((n, nn) => {
        n.forEach((w, ww) => {
          if (ww === n.length - 1 && Number(this.$moment(w.start).format('DD')) > 25) {
            for (let d = new Date((Number(this.$moment(this.startdate).format('YYYY')) + nn) + '-' + this.$moment(w.start).format('MM-DD')).getTime(); d <= new Date((Number(this.$moment(this.startdate).format('YYYY')) + nn + 1) + '-' + this.$moment(w.end).format('MM-DD')).getTime(); d = d + 86400000) {
              // console.log(this.$moment(d).format('YYYY-MM-DD'))
              if (this.contentDateList.indexOf(this.$moment(d).format('YYYY-MM-DD')) !== -1) {
                array.push(Number((Number(this.$moment(this.startdate).format('YYYY')) + nn) + (ww < 10 ? '0' + String(ww) : String(ww))))
              }
            }
          }
          for (let d = new Date((Number(this.$moment(this.startdate).format('YYYY')) + nn) + '-' + this.$moment(w.start).format('MM-DD')).getTime(); d <= new Date((Number(this.$moment(this.startdate).format('YYYY')) + nn) + '-' + this.$moment(w.end).format('MM-DD')).getTime(); d = d + 86400000) {
            // console.log(this.$moment(d).format('YYYY-MM-DD'))
            if (this.contentDateList.indexOf(this.$moment(d).format('YYYY-MM-DD')) !== -1) {
              array.push(Number((Number(this.$moment(this.startdate).format('YYYY')) + nn) + (ww < 10 ? '0' + String(ww) : String(ww))))
            }
          }
        })
      })
      return array
    }
  },
  watch: {
    processloadingView (val) {
      if (!val && !this.overload) {
        this.processingView = true
      } else if (!val && this.overload) {
        if (!this.systemTrigger) {
          alert(this.overloadMsg)
        }
      }
    },
    summaryVendorName (val) {
      this.getModelName(val)
    },
    summaryModelName (val) {
      this.getPartNumber(this.summaryVendorName, val)
    },
    summaryPartNumber (val) {
      this.contentDateList = []
      if (val) this.getContentDateList(this.summaryVendorName, this.summaryModelName, val)
    },
    chartLineView (val) {
      if (val) {
        this.barXaxisName = ['x']
        this.barXaxisStandard = ['常態分佈']
        this.barXaxisValue = ['統計次數']
        if (this.responseStandardData.distributionCoverageList.length > 0) {
          this.responseStandardData.distributionCoverageList.forEach((r) => {
            if (r.define.type === 'Sigma') {
              this.barXaxisName.push(r.define.name)
              if (this.responseStandardData.standardDeviation === 0) {
                this.barXaxisStandard.push(r.amount.toFixed(3))
              } else {
                this.barXaxisStandard.push(new NormalDistribution(this.responseStandardData.average, this.responseStandardData.standardDeviation).pdf(r.define.value).toFixed(3))
              }
              this.barXaxisValue.push(r.amount)
            }
          })
        }
        if (this.chartLineViewNum === 0) {
          this.handler_line.$emit('init', this.options_line)
          this.chartLineViewNum++
        } else {
          this.handler_line.$emit('dispatch', chart => {
            const options = {
              columns: [
                this.barXaxisName,
                this.barXaxisStandard,
                this.barXaxisValue
              ]
            }
            chart.load(options)
            chart.xgrids(this.responseStandardUpperLower)
          })
        }
      } else {
        // this.handler_line.$emit('destroy')
      }
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/keypart/keyboard/keyboardManufacturingReport')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          JSON.parse(localStorage.getItem('moduleDataInitDate')).forEach((n) => {
            if (n.name === 'keyboard') {
              this.startdate = n.value
            }
          })
          if (this.$route.params.searchWeeksStart && this.$route.params.searchWeeksEnd && this.$route.params.searchVendorName && this.$route.params.searchModelName && this.$route.params.searchPartNumber) {
            this.summaryWeeksStart = Number(this.$route.params.searchWeeksStart)
            this.summaryWeeksEnd = Number(this.$route.params.searchWeeksEnd)
            this.tempVendorName = this.$route.params.searchVendorName
            this.tempModelName = this.$route.params.searchModelName
            this.tempPartNumber = this.$route.params.searchPartNumber
            if (this.$route.params.systemTrigger === 'systemTrigger') {
              this.systemTrigger = true
            }
          }
          this.$http.get('/api/keypart/keyboard/vendorName').then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                this.summaryVendorNameMenu = []
                res.data.forEach((n) => {
                  this.summaryVendorNameMenu.push({ text: n, value: n })
                })
                if (this.tempVendorName !== '') {
                  this.summaryVendorName = this.tempVendorName
                }
              }
            })

          this.loadData()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    async loadData () {
      this.loadingView = true
      await this.YearWeeksList()
      await this.AllYearWeeksList()
    },
    YearWeeksList () {
      const Arr = []
      const YearStart = this.$moment(this.startdate).format('YYYY')
      const YearEnd = this.$moment(new Date()).format('YYYY')
      let NewYear = false
      let YearEndWeek = 0

      for (let y = 0; y <= (YearEnd - YearStart + 1); y++) {
        Arr[y] = []
        let w = 0
        let n = 0
        let day = new Date(Number(YearStart) + y + '-01-01').getTime()
        if (y === 0 && this.$moment(this.startdate).format('MM-DD') !== '01-01') {
          day = new Date(Number(YearStart) + y + '-' + this.$moment(this.startdate).format('MM-DD')).getTime()
          w = Math.ceil((((new Date(this.$moment(this.startdate).format('YYYY-MM-DD')) - new Date(new Date(this.$moment(this.startdate).format('YYYY'), 0, 1))) / 86400000) + new Date(new Date(this.$moment(this.startdate).format('YYYY'), 0, 1)).getDay()) / 7)
          if (new Date(this.$moment(this.startdate).format('YYYY') + '-01-01').getDay() > 0) {
            w = w - 1
          }
          Arr[y][w] = { start: this.$moment(this.startdate).format('YYYY-MM-DD'), end: '' }
          if (new Date(this.$moment(this.startdate).format('YYYY-MM-DD')).getDay() === 6) {
            Arr[y][w].end = this.$moment(this.startdate).format('YYYY-MM-DD')
          } else if (new Date(this.$moment(this.startdate).format('YYYY-MM-DD')).getDay() === 0) {
            w = w - 1
          }
        } else if (new Date(Number(YearStart) + y + '-01-01').getDay() !== 0) {
          n = 6 - new Date(Number(YearStart) + y + '-01-01').getDay()
          Arr[y][1] = { start: '', end: '' }
        }
        for (let d = (day + (86400000 * n)); d <= (new Date(Number(YearStart) + y + '-12-31').getTime()); d = d + 86400000) {
          if (y > 0 && new Date(d).getDay() === 6) {
            if (Arr[y][1].start === '') {
              Arr[y - 1][YearEndWeek].end = this.$moment(d).format('YYYY-MM-DD')
              Arr[y][0] = { start: Arr[y - 1][YearEndWeek].start, end: this.$moment(d).format('YYYY-MM-DD') }
              w = 0
              YearEndWeek = w
              NewYear = true
            }
          }
          if (new Date(d).getDay() === 0) {
            w++
            YearEndWeek = w
            NewYear = false
            Arr[y][w] = { start: this.$moment(d).format('YYYY-MM-DD'), end: '' }
          } else if (!NewYear && new Date(d).getDay() === 6) {
            Arr[y][w].end = this.$moment(d).format('YYYY-MM-DD')
          }
        }
      }
      this.summaryYearWeeksList = Arr
    },
    AllYearWeeksList () {
      const Arr = []
      const YearStart = this.$moment(this.startdate).format('YYYY')
      let YearEnd = this.$moment(this.summaryMonth).format('YYYY')
      let LastYear = 0
      if (new Date(this.$moment(this.summaryMonth).format('YYYY') + '-01-01').getDay() > 0) {
        LastYear = 1
      }
      const WeeksEnd = Math.ceil((((new Date(this.$moment(new Date()).format('YYYY-MM-DD')) - new Date(new Date(this.$moment(this.summaryMonth).format('YYYY'), 0, 1))) / 86400000) + new Date(new Date(this.$moment(this.summaryMonth).format('YYYY'), 0, 1)).getDay()) / 7) - LastYear
      if (WeeksEnd === 0) {
        YearEnd--
      }
      for (let y = 0; y <= (YearEnd - YearStart); y++) {
        for (let w = 1; w < this.summaryYearWeeksList[y].length; w++) {
          if (y === (YearEnd - YearStart) && w === WeeksEnd) {
            Arr.push({ text: (Number(YearStart) + y) + '　w' + w + '　( ' + this.$moment(this.summaryYearWeeksList[y][w].start).format('MM-DD') + ' ～ ' + this.$moment(this.summaryYearWeeksList[y][w].end).format('MM-DD') + ' )', value: (Number(YearStart) + y) * 100 + w })
            break
          }
          if (this.summaryYearWeeksList[y][w]) {
            Arr.push({ text: (Number(YearStart) + y) + '　w' + w + '　( ' + this.$moment(this.summaryYearWeeksList[y][w].start).format('MM-DD') + ' ～ ' + this.$moment(this.summaryYearWeeksList[y][w].end).format('MM-DD') + ' )', value: (Number(YearStart) + y) * 100 + w })
          }
        }
      }
      Arr.sort(function (a, b) { return b.value - a.value })
      this.summaryAllYearWeeksList = Arr
      this.loadingView = false
    },
    responseCpkDataCompileGroup (groupType, data) {
      const array = []
      data.forEach((i, ii) => {
        if (array.map(function (e) { return e.buttonCode }).indexOf(i[groupType]) === -1) {
          array.push({ buttonCode: i[groupType], item: [i] })
        } else {
          array[array.map(function (e) { return e.buttonCode }).indexOf(i[groupType])].item.push(i)
        }
      })
      // array.item.sort((a, b) => a.testItemName.localeCompare(b.testItemName))
      return array
    },
    responseProblemDataCompileKey (data) {
      const array = []
      data.forEach((i, ii) => {
        i.buttonCode.forEach((c, cc) => {
          if (array.indexOf(c) === -1) {
            array.push(c)
          }
        })
      })
      array.sort((a, b) => a.localeCompare(b))
      return array
    },
    getCpkGradeList () {
      this.$http.get('/api/keypart/support/cpkEvaluationList').then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.CpkGradeList = res.data
          }
        })
    },
    doCpkGrade (cpk) {
      let result = false
      this.CpkGradeList.forEach(e => {
        if ((e.upperSpecLimit ? e.upperSpecLimit : 999999999999999) > cpk && cpk >= (e.lowerSpecLimit ? e.lowerSpecLimit : -999999999999999)) {
          result = (e.status === 'qualified')
        }
      })
      return result
    },
    doCpkGradeName (cpk) {
      let result = false
      this.CpkGradeList.forEach(e => {
        if ((e.upperSpecLimit ? e.upperSpecLimit : 999999999999999) > cpk && cpk >= (e.lowerSpecLimit ? e.lowerSpecLimit : -999999999999999)) {
          result = e.evaluation
        }
      })
      return result
    },
    getModelName (vendor) {
      this.$http.get(`/api/keypart/keyboard/modelName/${vendor}`).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryModelNameMenu = []
            this.summaryModelName = ''
            this.summaryPartNumberMenu = []
            this.summaryPartNumber = ''
            res.data.forEach((n) => {
              this.summaryModelNameMenu.push({ text: n, value: n })
            })
            if (this.tempModelName !== '') {
              this.summaryModelName = this.tempModelName
            }
          }
        })
    },
    getPartNumber (vendor, model) {
      const body = {
        vendorName: vendor,
        modelName: model
      }
      this.$http.get('/api/keypart/keyboard/partNumber?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryPartNumberMenu = []
            this.summaryPartNumber = ''
            res.data.forEach((n) => {
              this.summaryPartNumberMenu.push({ text: n, value: n })
            })
            if (this.tempPartNumber !== '') {
              this.summaryPartNumber = this.tempPartNumber
              this.tempVendorName = ''
              this.tempModelName = ''
              this.tempPartNumber = ''
              this.doSubmit()
            }
          }
        })
    },
    getContentDateList (vendor, model, partNumber) {
      const body = {
        vendorName: vendor,
        modelName: model,
        partNumber: partNumber
      }
      this.$http.get('/api/keypart/keyboard/uploadedFileDate?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.contentDateList = res.data
          }
        })
    },
    async doSubmit () {
      if (this.summaryWeeksEnd < this.summaryWeeksStart) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '結尾時間不得早於起始時間'
      } else {
        this.processingView = false
        this.summaryNoData = true
        this.summaryLoading = {
          Rgb: true,
          Feeling: true,
          Key_Height: true,
          Luminance: true,
          Aoi: true,
          Problem_Feeling: true,
          Problem_Key_Height: true,
          Problem_Luminance: true,
          Problem_Aoi: true
        }
        this.overload = false
        this.overloadMsg = ''
        let wwS = 0
        let wwE = 0
        if (Number.isInteger(this.summaryWeeksStart)) {
          wwS = String(this.summaryWeeksStart).substr(4)
        } else {
          wwS = Math.ceil((((new Date(this.$moment(new Date()).format('YYYY-MM-DD')) - new Date(new Date(this.$moment(new Date()).format('YYYY'), 0, 1))) / 86400000) + new Date(new Date(this.$moment(new Date()).format('YYYY'), 0, 1)).getDay()) / 7) - parseInt((new Date(this.$moment(new Date()).format('YYYY') + '-01-01').getDay() + 5) / 6)
        }
        if (Number.isInteger(this.summaryWeeksEnd)) {
          wwE = String(this.summaryWeeksEnd).substr(4)
        } else {
          wwE = Math.ceil((((new Date(this.$moment(new Date()).format('YYYY-MM-DD')) - new Date(new Date(this.$moment(new Date()).format('YYYY'), 0, 1))) / 86400000) + new Date(new Date(this.$moment(new Date()).format('YYYY'), 0, 1)).getDay()) / 7) - parseInt((new Date(this.$moment(new Date()).format('YYYY') + '-01-01').getDay() + 5) / 6)
        }
        const uploadedDateStart = this.$moment(this.summaryYearWeeksList[String(this.summaryWeeksStart).substr(0, 4) - this.$moment(this.startdate).format('YYYY')][Number(wwS)].start).format('YYYY-MM-DD')
        const uploadedDateEnd = this.$moment(this.summaryYearWeeksList[String(this.summaryWeeksEnd).substr(0, 4) - this.$moment(this.startdate).format('YYYY')][Number(wwE)].end).format('YYYY-MM-DD')
        const manufactureWeeksStart = this.summaryWeeksStart
        const manufactureWeeksEnd = this.summaryWeeksEnd
        const vendorName = this.summaryVendorName
        const modelName = this.summaryModelName
        const partNumber = this.summaryPartNumber
        this.responseCpkData = {
          Rgb: [],
          Feeling: [],
          Key_Height: [],
          Luminance: [],
          Aoi: []
        }
        this.responseProblemData = {
          Feeling: [],
          Key_Height: [],
          Luminance: [],
          Aoi: []
        }
        this.responseProblemDataCompile = {
          Feeling: [],
          Key_Height: [],
          Luminance: [],
          Aoi: []
        }
        await this.getCpkGradeList()
        await this.doSubmitType('Rgb', 'group', vendorName, modelName, partNumber, uploadedDateStart, uploadedDateEnd)
        await this.doSubmitType('Feeling', 'testItemName', vendorName, modelName, partNumber, uploadedDateStart, uploadedDateEnd)
        await this.doSubmitType('Key_Height', 'group', vendorName, modelName, partNumber, uploadedDateStart, uploadedDateEnd)
        await this.doSubmitType('Luminance', 'group', vendorName, modelName, partNumber, uploadedDateStart, uploadedDateEnd)
        await this.doSubmitType('Aoi', 'group', vendorName, modelName, partNumber, uploadedDateStart, uploadedDateEnd)
        await this.doSubmitAfter(vendorName, modelName, partNumber, uploadedDateStart, uploadedDateEnd, manufactureWeeksStart, manufactureWeeksEnd)
      }
    },
    doSubmitType (type, groupType, vendorName, modelName, partNumber, uploadedDateStart, uploadedDateEnd) {
      const body = {
        uploadedDateStart: uploadedDateStart,
        uploadedDateEnd: uploadedDateEnd,
        vendorName: vendorName,
        modelName: modelName,
        partNumber: partNumber,
        type: type,
        systemTrigger: this.systemTrigger
      }
      this.$http.get('/api/keypart/keyboard/summaryKeyboardUploadedDataList?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            if (res.data.length > 0) {
              this.summaryNoData = false
              this.responseCpkData[type] = this.responseCpkDataCompileGroup(groupType, res.data)
            }
            this.summaryLoading[type] = false
          } else { // failure
            if (this.systemTrigger) {
              this.overloadMsg = this.overloadMsg + '<br>[' + type + '] ' + res.errMsg
              this.summaryLoading[type] = false
            } else {
              this.overload = true
              this.overloadMsg = '系統錯誤，請洽系統管理人員\n錯誤訊息：' + res.errMsg
              this.summaryLoading[type] = false
            }
          }
        })
        .catch(err => {
          if (this.systemTrigger) {
            this.overloadMsg = this.overloadMsg + '<br>[' + type + '] ' + err
            this.summaryLoading[type] = false
          } else {
            this.overload = true
            this.overloadMsg = '系統錯誤，請洽系統管理人員\n錯誤訊息：' + err
            this.summaryLoading[type] = false
          }
        })
      if (type !== 'Rgb') {
        this.$http.get('/api/keypart/keyboard/keyboardManufacturingProblemData?' + qs.stringify(body)).then(res => res.data)
          .then(res => {
            if (res.status === 'success') {
              if (res.data.length > 0) {
                this.summaryNoData = false
                this.responseProblemData[type] = res.data
                this.responseProblemDataCompile[type] = this.responseProblemDataCompileKey(res.data)
              }
              this.summaryLoading['Problem_' + type] = false
            } else { // failure
              if (this.systemTrigger) {
                this.overload = true
                this.overloadMsg = this.overloadMsg + '[' + type + '] ' + res.errMsg + '<br>'
                this.summaryLoading['Problem_' + type] = false
              } else {
                this.overload = true
                this.overloadMsg = '系統錯誤，請洽系統管理人員\n錯誤訊息：' + res.errMsg
                this.summaryLoading['Problem_' + type] = false
              }
            }
          })
          .catch(err => {
            if (this.systemTrigger) {
              this.overload = true
              this.overloadMsg = this.overloadMsg + '[' + type + '] ' + err + '<br>'
              this.summaryLoading['Problem_' + type] = false
            } else {
              this.overload = true
              this.overloadMsg = '系統錯誤，請洽系統管理人員\n錯誤訊息：' + err
              this.summaryLoading['Problem_' + type] = false
            }
          })
      }
    },
    doSubmitAfter (vendorName, modelName, partNumber, uploadedDateStart, uploadedDateEnd, manufactureWeeksStart, manufactureWeeksEnd) {
      this.responseVendorName = vendorName
      this.responseModelName = modelName
      this.responsePartNumber = partNumber
      this.responseDateStart = uploadedDateStart
      this.responseDateEnd = uploadedDateEnd
      this.responseWeeksStart = manufactureWeeksStart
      this.responseWeeksEnd = manufactureWeeksEnd
      const Url = '/keypart/keyboard/keyboardManufacturingReport/' + this.responseWeeksStart + '/' + this.responseWeeksEnd + '/' + this.responseVendorName + '/' + this.responseModelName + '/' + this.responsePartNumber + (this.systemTrigger ? '/systemTrigger' : '')
      if (this.$router.history.current.path !== Url) {
        this.$router.replace(Url)
      }
    },
    doSubmitSingle (type, buttonCode, testItemName) {
      this.loadingView = true

      const body = {
        uploadedDateStart: this.responseDateStart,
        uploadedDateEnd: this.responseDateEnd,
        vendorName: this.responseVendorName,
        modelName: this.responseModelName,
        partNumber: this.responsePartNumber,
        type: type,
        buttonCode: buttonCode,
        testItemName: testItemName
      }

      this.$http.get('/api/keypart/keyboard/singleKeyboardCpkItem?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.responseStandardData = res.data
            this.responseStandardData.distributionCoverageList.sort(function (a, b) {
              return parseFloat(a.define.value) - parseFloat(b.define.value)
            })
            this.chartViewButtonCode = buttonCode
            this.chartViewTestItemName = testItemName
            this.chartLineView = true
            this.loadingView = false
          } else { // failure
            this.loadingView = false
            alert('系統錯誤，請洽系統管理人員\n錯誤訊息：' + res.errMsg)
          }
        })
        .catch(err => {
          this.loadingView = false
          alert('系統錯誤，請洽系統管理人員\n錯誤訊息：' + err)
        })
    }
  }
}
</script>
<style>
</style>
